import { useTranslation } from '@wix/yoshi-flow-editor';
import { RatingsTranslationsKey } from '~ratings/locale-types';

export type RatingsTranslationsFn = (key: RatingsTranslationsKey, params?: any) => string;

export const useTranslate = () => {
  const { t } = useTranslation();
  return t as RatingsTranslationsFn;
};
